import { useQuery } from '@tanstack/react-query'
import { ExtendableQueryOptions } from 'shared/api/api.types'

import { taskManagementApi } from '../..'
import {
  AppSettingKey,
  AppSettingValueMap
} from '../../taskManagementApi.types'
import { GetAppSettingResponse } from './getAppSetting.types'

export const getAppSetting = async <K extends AppSettingKey>(
  key: K
): Promise<AppSettingValueMap[K]> => {
  const response = await taskManagementApi.get<GetAppSettingResponse<K>>(
    `/api/app-settings/${key}`
  )
  return response.data.data.value
}

export const GET_APP_SETTING_QUERY_KEY = 'task-management-app-setting'

export const useGetAppSettingQuery = <K extends AppSettingKey>(
  key: K,
  options?: ExtendableQueryOptions<AppSettingValueMap[K]>
) =>
  useQuery({
    queryKey: [GET_APP_SETTING_QUERY_KEY, key],
    queryFn: () => getAppSetting(key),
    ...options
  })
